import { createLogic } from 'redux-logic';
import store from 'store';

// Actions
const GO = '@@app/redirect/GO';
const SET = '@@app/redirect/SET';

const goLogic = createLogic({
  type: GO,
  process({}, dispatch, done) {
    const { path } = store.get('redirect');
    window.location.assign(path);
    done();
  },
});

const setLogic = createLogic({
  type: SET,
  process({ action }, dispatch, done) {
    const { path } = action.payload;
    store.set('redirect', path);
    done();
  },
});

export const redirectLogic = [goLogic, setLogic];

// Action Creators
export const goRedirect = path => {
  return { type: GO, payload: { path } };
};

export const setRedirect = path => {
  return { type: SET, payload: { path } };
};



// WEBPACK FOOTER //
// ./src/logic/redirect.js